/**
 * GetInsurances SSC Endpoint
 *
 * Fetches available insurance products for a given booking basket.
 */
import { sscClient } from './sscClient';
import { SSC_ENDPOINTS } from './config';
import {
  GetInsurancesResponseSchema,
  type GetInsurancesRequest,
  type GetInsurancesResponse,
} from '@/types/schemas/ssc';

export async function getInsurances(request: GetInsurancesRequest): Promise<GetInsurancesResponse> {
  return sscClient.post<GetInsurancesRequest, GetInsurancesResponse>({
    endpoint: SSC_ENDPOINTS.GET_INSURANCES,
    data: request,
    responseSchema: GetInsurancesResponseSchema,
  });
}
